import { useMediaModal } from './useMediaModal'
import { useMediaEditor } from './useMediaEditor'
import { useMediaDeletion } from './useMediaDeletion'

export const useMediaGallery = (eventId, onMediaUpdate, onError) => {
  const modalHandlers = useMediaModal()
  const editorHandlers = useMediaEditor(eventId, onMediaUpdate, onError)
  const deletionHandlers = useMediaDeletion(eventId, onMediaUpdate, onError)

  const closeModal = () => {
    modalHandlers.closeModal()
    editorHandlers.cancelEdit('name')
    editorHandlers.cancelEdit('description')
  }

  const deleteMedia = (mediaId, isOwner) => {
    deletionHandlers.deleteMedia(mediaId, closeModal)
  }

  return {
    selectedMedia: modalHandlers.selectedMedia,
    loading: editorHandlers.loading || deletionHandlers.loading,
    openModal: modalHandlers.openModal,
    closeModal,
    deleteMedia,
    ...editorHandlers
  }
}